import { useEffect, useContext } from "react";
import { getUrlParameterBykeys } from "../utilities/urlHelper";
import { Global } from "../context/globalContextProvider";

/**
 * This could be used in all forms under components/form/*
 * @param {function} setDonationAmount
 * @param {function} setDonationFrequency
 * @param {function} setIsFormLoaded
 * @param {number|string} defaultAmount
 */
const useFormInitFieldWithUrlParams = (defaultAmount = 10) => {
  const { setDonationAmount, setIsFormLoaded, setDonationFrequency } = useContext(Global);

  useEffect(function updateFormByUrlParams() {
    const { amount, selection } = getUrlParameterBykeys(["amount", "selection"]);
    if (amount && !isNaN(Number(amount))) {
      setDonationAmount(amount);
    } else if (!isNaN(Number(defaultAmount))) {
      setDonationAmount(defaultAmount);
    }

    if (selection) {
      setDonationFrequency(selection);
    }

    setIsFormLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useFormInitFieldWithUrlParams;
